export const ALERT_ADD_MESSAGE = '@ALERT/ADD_MESSAGE';
export const ALERT_CLEAR  = '@ALERT/CLEAR';

export const actionCreators = {
    alertAddMessage: (alert) =>  ({ type: ALERT_ADD_MESSAGE, payload: alert }),
    alertClear: () =>  ({ type: ALERT_CLEAR, payload: null }),
};
